export default ({ props }) => {
  return {
    wrapper: {
      marginLeft: '44px',
      marginRight: '20px',
      marginTop: '24px',
      marginBottom: '24px',
    },
  }
}
